/**
 * BOSIScore component - Traffic-light indicator showing BOSI Score.
 * Displays color circle, label, and sub-label based on body state assessment.
 */

import React from 'react';
import { BOSIScore as BOSIScoreType } from '../../types';

interface BOSIScoreProps {
  score: BOSIScoreType;
}

const COLOR_CONFIG: Record<string, { bg: string; ring: string; text: string; glow: string }> = {
  green: {
    bg: 'bg-green-500',
    ring: 'ring-green-200',
    text: 'text-green-700',
    glow: 'shadow-[0_0_20px_rgba(34,197,94,0.3)]',
  },
  yellow: {
    bg: 'bg-yellow-400',
    ring: 'ring-yellow-200',
    text: 'text-yellow-700',
    glow: 'shadow-[0_0_20px_rgba(234,179,8,0.3)]',
  },
  red: {
    bg: 'bg-red-500',
    ring: 'ring-red-200',
    text: 'text-red-700',
    glow: 'shadow-[0_0_20px_rgba(239,68,68,0.3)]',
  },
};

const BOSIScoreDisplay: React.FC<BOSIScoreProps> = ({ score }) => {
  const config = COLOR_CONFIG[score.color] || COLOR_CONFIG.yellow;

  return (
    <div className="flex items-center space-x-4">
      <div
        className={`w-12 h-12 rounded-full ${config.bg} ${config.glow} ring-4 ${config.ring}`}
        aria-label={`BOSI Score: ${score.color}`}
      />
      <div>
        <div className={`text-xl font-bold ${config.text}`}>
          {score.label}
        </div>
        {score.sub_label && (
          <div className="text-sm text-neutral-600 mt-0.5">
            {score.sub_label}
          </div>
        )}
      </div>
    </div>
  );
};

export default BOSIScoreDisplay;
